import type { BranchStep } from '../../../../dorian-shared/types/branch/BranchStep';
import { StepTypes } from '../../../../dorian-shared/types/branch/BranchStep';
import type { HubOption } from '../../../../dorian-shared/types/branch/HubOption';
import { serializeHubOptionMods, applyHubOptionSerializers } from './Steps/StepTypeHub/hubSerialize';
import { deepCloneOption } from './Steps/StepTypeHub/hubOptionClone';
// Side-effect import: registers every mods serializer (border/score/tags/progressBars)
// so serializeHubOptionMods covers the full override class, not a partial view.
import './Steps/StepTypeHub/hubOptionTransform';

// Variant switch point: returning false drops a condition before serialization.
// Variant 1 keeps everything as-is; flip this body to filter empty/invalid for Variant 2.
const keepCondition = (_condition: unknown): boolean => true;

const CONDITION_KEYS = [
  'stateConditions', 'replayConditions', 'textDestConditions', 'iconConditions',
  'tagTopConditions', 'tagBottomConditions', 'borderConditions',
] as const;

function bridgeOption(option: HubOption): HubOption {
  const clone = deepCloneOption(option);

  CONDITION_KEYS.forEach((key) => {
    const conditions = clone[key] as unknown[] | undefined;
    if (Array.isArray(conditions)) {
      (clone[key] as unknown[]) = conditions.filter(keepCondition);
    }
  });

  clone.mods = serializeHubOptionMods(clone);
  applyHubOptionSerializers(clone);

  return clone;
}

/**
 * Rebuilds opt.mods and normalises opt.score for every Hub option so live override
 * edits (which write *Conditions / flat score) reach the emulator transform, which
 * reads opt.mods and the API-shaped opt.score. Pure: clones via deepCloneOption,
 * never mutates the input. Non-Hub steps pass through untouched.
 */
export function bridgeHubOptionMods(steps: BranchStep[]): BranchStep[] {
  return steps.map((step) => {
    if (step.stepTypeId !== StepTypes.Hub || !Array.isArray(step.hubOptions)) {
      return step;
    }
    return {
      ...step,
      hubOptions: step.hubOptions.map(bridgeOption),
    };
  });
}
